import styled from 'styled-components';
import { Gilroy } from '../../../font';
import { Title, Caption, Header3, Subtitle, ButtonTextLarge } from '../../../typographies';
import { ColorAddiBackgroundWhite, ColorAddiCompFiveBase, ColorAddiCompThreeLighten1, ColorAddiFontOverDark, ColorAddiFontPrimary, } from '@addi/foundation/dist/web/colors';
import { SizeAddiFontSmall, SizeAddiFontXSmall, SizeAddiFontXxSmall } from '@addi/foundation/dist/web/sizes';
import { FontAddiWeightExtraLight, FontAddiWeightMedium, FontAddiWeightBold } from '@addi/foundation/dist/web/fonts';
export const TextTitle = styled(Title) `
  color: ${({ color }) => color ? color : ColorAddiFontPrimary};
  max-width: 260px;
  margin: auto;
`;
export const ProposalContainer = styled.div `
  width: auto;
  height: fit-content;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 10px 15px;
`;
export const ProposalContent = styled.div `
  width: auto;
  height: fit-content;
  display: flex;
  flex-direction: column;
  text-align: center;
`;
export const DiscountProposalContent = styled.div `
  width: auto;
  height: fit-content;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  padding: 10px 15px;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : ColorAddiBackgroundWhite};
  margin-bottom: 20px;
`;
export const DiscountProposalIcon = styled.div `
  width: auto;
  height: auto;
  padding: 0 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const CurrencySymbol = styled.span `
    ${ButtonTextLarge};
    
    font-size: ${SizeAddiFontXSmall};
    margin: 4px 5px 0 0;
`;
export const DiscountProposalText = styled.div `
  width: auto;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
`;
export const TermPriceLabel = styled(Caption) `
    font-size: ${SizeAddiFontSmall};
    color: ${ColorAddiFontOverDark};
    margin: 0;
    position: relative;
`;
export const DiscountedPriceLabel = styled(Title) `
  color: ${ColorAddiFontOverDark};
  padding: 0;
  margin: 0 0 2px 0;
  display: flex;
`;
export const OriginalPriceLabel = styled(Subtitle) `
  font-size: ${SizeAddiFontSmall};
  font-weight: ${FontAddiWeightBold};
  text-decoration: line-through;
  padding: 0;
  margin: 2px 0;
`;
export const TermCostLabel = styled(Caption) `
  color: ${props => props.color ? props.color : ColorAddiFontPrimary};
  font-size: ${SizeAddiFontXSmall};
  font-weight: ${FontAddiWeightMedium}; 
  font-style: normal;
  margin: 12px 0;
`;
export const InstallmentLabel = styled(Header3) `
  color: ${props => props.color ? props.color : ColorAddiCompFiveBase};
  font-style: normal;
  margin: auto;
`;
export const PriceCard = styled.div `
  display: flex;
  flex-direction: column;
  color: ${ColorAddiFontOverDark};
  margin: 5px 0;
`;
export const PriceLabel = styled(Gilroy) `
  font-size: ${props => props.smallText ? '1.15rem' : '1.8rem'};
  font-weight: Bold; 
  font-style: normal;
  text-decoration: ${props => props.lineThrough ? 'line-through' : 'none'};
`;
export const FinePrint = styled(Caption) `
  font-size: ${SizeAddiFontXxSmall};
  font-weight: ${FontAddiWeightExtraLight};
  font-color: ${ColorAddiFontOverDark};
  display: block;
  font-style: normal;
  padding: 0 10px;
  margin: 10px 0;

  & b {
    font-weight: bold;
  }
`;
export const Badge = styled.div `
    background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : ColorAddiCompThreeLighten1};
    padding: 2px 15px;
    margin: 10px auto 0;
    border-radius: ${({ borderRadius }) => borderRadius ? borderRadius : '5px'};
`;
export const BadgeText = styled(Caption) `
    color: ${({ color }) => color ? color : ColorAddiFontOverDark};
    font-weight: ${FontAddiWeightBold};
`;
//# sourceMappingURL=loan-proposal-card.styled.js.map